package com.zaurh.mapquizwebsite.domain.model

import com.zaurh.mapquizwebsite.utils.EMPTY
import com.zaurh.mapquizwebsite.utils.ZERO
import com.zaurh.mapquizwebsite.utils.ZERO_LONG
import kotlinx.serialization.Serializable

@Serializable
data class UserDataDO(
    val id: String = EMPTY,
    val username: String = EMPTY,
    val record: List<RecordDataDO> = listOf(),
    val gold: Long = ZERO_LONG,
    val cash: Long = ZERO_LONG,
    val experience: Long = ZERO_LONG,
    val countryStats: List<CountryStatDO> = listOf(),
    val ownedMaps: List<String> = listOf(),
    val collections: List<String> = listOf(),
    val createdDate: Long = ZERO_LONG,
    val userStats: UserStatsDO = UserStatsDO()
)

@Serializable
data class CountryStatDO(
    val countryCode: String = EMPTY,
    val foundCount: Int = 0
)

@Serializable
data class RecordDataDO(
    val quizMode: QuizMode = QuizMode.COUNTRIES,
    val gameMode: GameMode = GameMode.CLASSIC,
    val area: Area = Area.ALL_COUNTRIES,
    val record: Int = ZERO
)

@Serializable
enum class QuizMode {
    COUNTRIES, CAPITALS, FLAGS
}

@Serializable
enum class GameMode {
    CLASSIC, SPEEDRUN, PUZZLE, JUMP, QUIZ, COUNTRY_DUEL
}

@Serializable
enum class Area {
    ALL_COUNTRIES, ASIA, EUROPE, AFRICA, NORTH_AMERICA, SOUTH_AMERICA, OCEANIA
}

@Serializable
data class UserStatsDO(
    val totalGoldEarned: Long = ZERO_LONG,
    val totalCashEarned: Long = ZERO_LONG,
    val totalChestOpenings: Long = ZERO_LONG,
    val totalGamesPlayed: Long = ZERO_LONG,
    val totalCountriesFound: Long = ZERO_LONG,
    val gameModes: Map<Int, Long> = emptyMap(),
    val quizModes: Map<String, Long> = emptyMap(),
    val areas: Map<String, Long> = emptyMap()
)